import React from 'react';

const ContactMap = () => {
    return (
        <section className="wpo-contact-map-section">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 col-md-12 mb-4">
                      <div className="wpo-contact-map">
    <iframe
        title="Mahalaxmi Residency Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3791.004489185931!2d74.58374947192274!3d18.16370714498531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc3a01cbdc93609%3A0x4ec862bbc6e62a38!2sMahalaxmi%20Residency!5e0!3m2!1sen!2sin!4v1754458442502!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
</div>

                    </div>

                    <div className="col-lg-6 col-md-12 mb-4">
                        <div className="wpo-contact-map">
                            <iframe
                                title="SNBS Location 2"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3785.4514225364655!2d75.1164186748159!3d18.417801782655896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc49b12aad16fc9%3A0xd99ef397911a568b!2sSNBS%20INDUSTRIES%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1754394310606!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactMap;
